module.exports = __webpack_public_path__ + "static/media/logo.b8ebebb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 243
// module chunks = 0